import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TuiRepeatTimes } from '@taiga-ui/cdk';
import { TuiScrollbar, TuiScrollable, TuiButton } from '@taiga-ui/core';

import { CarouselComponent } from './carousel.component';
import { CarouselButtonComponent } from './components';

@NgModule({
  declarations: [CarouselComponent, CarouselButtonComponent],
  imports: [CommonModule, TuiButton, TuiScrollbar, TuiScrollable, TuiRepeatTimes],
  exports: [CarouselComponent],
})
export class CarouselModule {}
